import React, {CSSProperties, FC} from "react";

import {cn} from "../../../../utils";

export type ChevronIconDirection = "left" | "right" | "up" | "down";

type OwnProps = {
  direction?: ChevronIconDirection;
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

type Props = OwnProps & Omit<React.SVGProps<SVGSVGElement>, keyof OwnProps | "color">;

const rotationByDirection: Record<ChevronIconDirection, number> = {
  left: 0,
  down: 90,
  right: 180,
  up: 270,
};

const ChevronIcon: FC<Props> = ({
  direction = "left",
  size = 24,
  color = "var(--primary-green-new)",
  strokeWidth = 1,
  className,
  style,
  title = "Chevron",
  ...svgProps
}) => {
  const rotate = rotationByDirection[direction];
  return (
    <svg
      className={cn(className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      style={{width: size, height: size, color, ...style}}
      {...svgProps}
    >
      <g transform={rotate === 0 ? undefined : `rotate(${rotate} 12 12)`}>
        <path
          d="M15 6L9 12L15 18"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default ChevronIcon;
